var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user--image",class:{ show: _vm.isActive }},[_c('a',{attrs:{"href":_vm.getUserId()}},[_c('img',{attrs:{"src":"/template/images/users/0.jpg","alt":"user"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }